  /**
   * @memberof SMART2
   * @ngdoc directive
   * @name Sliding-menu
   * @description This directive is useful for creating a sliding menu.
   * 
   * @attr {Number} right
   *    Menu's right position
   * @attr {Number} top
   *    Menu's top position
   * @attr {Boolean} show
   *    Sliding menu will toggle as soon as value of this attribute changes
   * @attr {Boolean} modify-parent-style
   *    This attribute is useful when parent does not need to animated. For e.g. Default behaviour is when 'show' is set to true, 
   *    parent element gets resized depending upon the width of sliding-menu.
   * @attr {Boolean} detach-default-class
   *    If this attribute is set to true, default class will not be applied to directive's template
   * @attr {String} include-template
   *    Template to be used
   * @attr {Object} tabData
   *    used for two-way communication based on this property
   *
   * @example
   Usage:
   <smart-sliding-menu>
        //  Contents will go here
   </smart-sliding-menu>
   */

(function () {
    'use strict';
    angular.module('SMART2').directive('smartSlidingMenu', ['RuleEngine', '$timeout', '$compile', '$translate', '$rootScope', function (RuleEngine, $timeout, $compile, $translate, $rootScope) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                right: '@',
                top: '@',
                show: '=',
                detachDefaultClass: '@',
                includeTemplate: '@',
                model: '@',
                modifyParentStyle: '@',
                tabData: '='
            },
            link: function (scope, $element, $attrs, controller) {
                scope.isRTL = !!window.isRTL;
                scope.getModel = function () {
                    return JSON.parse(scope.model);
                };
                if (scope.detachDefaultClass) {
                    if (scope.detachDefaultClass.toLowerCase() === "true") {
                    } else {
                        $element.addClass('secondary-navigation white');
                    }
                } else {
                    $element.addClass('secondary-navigation white');
                }

                scope.slidingMenuId = 'sliding-menu-' + new Date().getTime();
                scope.rightPos = scope.right ? scope.right : 0;
                scope.leftPos = window.innerWidth - scope.rightPos;

               scope.styleObj = {
                  left : 'calc(100% - '+ scope.rightPos +'px)',
                  top: top ? top + 'px' : '0px'
                } 
               if(scope.isRTL){
                 scope.styleObj = {
                  right : 'calc(100% - '+ scope.rightPos +'px)',
                  top: top ? top + 'px' : '0px'
                } 
               }
                scope.$watch('show', function (newValue, oldValue) {
                    if (newValue != undefined || newValue != null) {
                        if (newValue) {
                            if (scope.modifyParentStyle) {
                                if (scope.modifyParentStyle.toLowerCase() !== 'false') {
                                    $element.parent().css({
                                        width: 'calc(100% - ' + $element.outerWidth(true) + 'px)'
                                    });
                                }
                            }
                            var translateText = window.isRTL ? 'translateX(' : 'translateX(-'; 
                            $element.css({
                                transform: translateText + ($element.outerWidth(true) - scope.rightPos) + 'px)'
                            });
                            $('body').addClass('is-overflowHidden');
                        }
                        else {
                            if (scope.modifyParentStyle) {
                                if (scope.modifyParentStyle.toLowerCase() !== 'false') {
                                    $element.parent().css({
                                        width: 'calc(100% - ' + scope.rightPos + 'px)'
                                    });
                                }
                            }
                            $element.css({
                                transform: 'translateX(0px)'
                            });
                            $('body').removeClass('is-overflowHidden');
                            $('body').css('overflow','auto');
                        }
                    }
                });
            },
            templateUrl: 'shared/directives/slidingMenu/slidingMenuTemplate.html'
        };
    }]);
})();
